// Mémoriser et présélectionner la pointure
(function() {
  'use strict';
  
  const SIZE_STORAGE_KEY = 'jj_preferred_size';
  
  // Sauvegarder la pointure sélectionnée
  document.addEventListener('change', function(e) {
    const input = e.target;
    
    // Vérifier si c'est un input radio de variante
    if (input.type === 'radio' && input.closest('variant-picker')) {
      const label = document.querySelector(`label[for="${input.id}"]`);
      
      if (label) {
        const sizeText = label.querySelector('span');
        if (sizeText) {
          const size = sizeText.textContent.trim();
          // Sauvegarder uniquement si c'est un nombre (pointure)
          if (!isNaN(size)) {
            localStorage.setItem(SIZE_STORAGE_KEY, size);
            console.log('Pointure mémorisée:', size);
          }
        }
      }
    }
  });
  
  // Présélectionner la pointure mémorisée au chargement
  function preselectSize() {
    const preferredSize = localStorage.getItem(SIZE_STORAGE_KEY);
    
    if (!preferredSize) return;
    
    // Ne pas présélectionner si l'URL contient déjà un variant
    if (window.location.search.includes('variant=')) return;
    
    const variantPicker = document.querySelector('variant-picker');
    if (!variantPicker) return;
    
    // Trouver tous les labels avec la pointure mémorisée
    const labels = variantPicker.querySelectorAll('label');
    
    labels.forEach(function(label) {
      const sizeSpan = label.querySelector('span');
      if (sizeSpan && sizeSpan.textContent.trim() === preferredSize) {
        const inputId = label.getAttribute('for');
        const input = document.getElementById(inputId);
        
        if (input && !input.disabled) {
          input.click();
          console.log('Pointure présélectionnée:', preferredSize);
        }
      }
    });
  }
  
  // Attendre que le DOM soit chargé
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(preselectSize, 500);
    });
  } else {
    setTimeout(preselectSize, 500);
  }
})();